import { render, staticRenderFns } from "./TekaComponent.vue?vue&type=template&id=2015c24d&xmlns=true&"
import script from "./TekaComponent.vue?vue&type=script&lang=js&"
export * from "./TekaComponent.vue?vue&type=script&lang=js&"
import style0 from "./TekaComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2015c24d')) {
      api.createRecord('2015c24d', component.options)
    } else {
      api.reload('2015c24d', component.options)
    }
    module.hot.accept("./TekaComponent.vue?vue&type=template&id=2015c24d&xmlns=true&", function () {
      api.rerender('2015c24d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-multi-event/basic-data/forms/teka/TekaComponent.vue"
export default component.exports